/* eslint-disable indent */
/* eslint-disable import/prefer-default-export */
import instance from 'utils/axios/instance.axios';
import { PROPOSALS } from './_constant';

export const getAll = () =>
    instance.get(PROPOSALS.GET_ALL);

export const getAllWithFilters = (filters) =>
    instance.get(PROPOSALS.GET_ALL_FILTERS, { params: { ...filters } });

export const getAllResearchFields = () => instance.get(PROPOSALS.GET_ALL_RESEARCH_FIELDS);

export const createProposal = (data) => instance.post(PROPOSALS.CREATE_PROPOSAL, data);

export const updateProposal = (data) => instance.patch(PROPOSALS.UPDATE_PROPOSAL(data.id), data);

export const getProposalById = (id) => instance.get(PROPOSALS.GET_BY_ID(id));

export const deleteProposal = (id) => instance.delete(PROPOSALS.DELETE_PROPOSAL(id));

export const uploadProposalFile = (data) =>
    instance.post(PROPOSALS.UPLOAD_FILE, data);

export const downloadFile = (data) =>
    instance.post(PROPOSALS.DOWNLOAD_FILE, data, { responseType: 'blob' });
